module.exports = __webpack_public_path__ + "static/media/icon-arrow-white.42fbbc9d.svg";